// Single source of truth for the subpath prefix. CRA fills PUBLIC_URL from
// package.json "homepage" (= "/Platforms/Assetmanagement", no trailing slash;
// "" when unset). Anything that BYPASSES react-router — raw window.location,
// static <img src>, axios baseURL, WebSocket URLs, the service worker,
// reader-push URLs — must prefix with BASE. React-router (Link / NavLink /
// Navigate / useNavigate / Route) is handled by <BrowserRouter basename> — do
// NOT prefix those, or you double up the segment.
export const BASE = process.env.PUBLIC_URL || '';

// Dev runs CRA on :3000 and talks to the backend directly on :5001 with NO
// nginx prefix-stripping. So for anything that hits :5001 directly (WebSocket,
// reader push URL), suppress BASE in dev and keep it in prod.
export const backendBase = () =>
  window.location.host.endsWith(':3000') ? '' : BASE;
